var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoRoundGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8002 13C25.8002 16.3948 24.4516 19.6505 22.0512 22.051C19.6507 24.4514 16.395 25.8 13.0002 25.8C9.60542 25.8 6.34969 24.4514 3.94923 22.051C1.54876 19.6505 0.200195 16.3948 0.200195 13C0.200195 9.60524 1.54876 6.34951 3.94923 3.94905C6.34969 1.54858 9.60542 0.200012 13.0002 0.200012C16.395 0.200012 19.6507 1.54858 22.0512 3.94905C24.4516 6.34951 25.8002 9.60524 25.8002 13ZM14.6002 6.60001C14.6002 7.02436 14.4316 7.43132 14.1316 7.73138C13.8315 8.03144 13.4245 8.20001 13.0002 8.20001C12.5758 8.20001 12.1689 8.03144 11.8688 7.73138C11.5688 7.43132 11.4002 7.02436 11.4002 6.60001C11.4002 6.17567 11.5688 5.7687 11.8688 5.46864C12.1689 5.16858 12.5758 5.00001 13.0002 5.00001C13.4245 5.00001 13.8315 5.16858 14.1316 5.46864C14.4316 5.7687 14.6002 6.17567 14.6002 6.60001ZM11.4002 11.4C10.9758 11.4 10.5689 11.5686 10.2688 11.8686C9.96877 12.1687 9.80019 12.5757 9.80019 13C9.80019 13.4244 9.96877 13.8313 10.2688 14.1314C10.5689 14.4314 10.9758 14.6 11.4002 14.6V19.4C11.4002 19.8244 11.5688 20.2313 11.8688 20.5314C12.1689 20.8314 12.5758 21 13.0002 21H14.6002C15.0245 21 15.4315 20.8314 15.7316 20.5314C16.0316 20.2313 16.2002 19.8244 16.2002 19.4C16.2002 18.9757 16.0316 18.5687 15.7316 18.2686C15.4315 17.9686 15.0245 17.8 14.6002 17.8V13C14.6002 12.5757 14.4316 12.1687 14.1316 11.8686C13.8315 11.5686 13.4245 11.4 13.0002 11.4H11.4002Z",
    fill: "#7D7D7D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRoundGrey);
export default __webpack_public_path__ + "static/media/info-round-grey.6234a422bbec01704eb01bedd0eac977.svg";
export { ForwardRef as ReactComponent };